export enum ConsultTrackingResultType {
    Failed = -1,
    Success = 1
}